import { EntityType } from 'app/assessment/models/entity-type.enum';
import { User, UserInterface } from 'app/core/user/models/user.model';

import { AssessmentAnalysisInterface } from './assessment-analysis.model';
import { AssessmentPageInterface } from './assessment-page.model';

export interface AssessmentInterface {
  id?: number;
  type?: EntityType;
  subject?: UserInterface;
  admin?: UserInterface;
  date?: Date;
  createdDate?: Date;
  updateDate?: Date;
  isComplete?: boolean;
  haveCompletedSurvey?: boolean;
  pages?: AssessmentPageInterface[];
  analysis?: AssessmentAnalysisInterface;
}


export abstract class Assessment implements AssessmentInterface {
  public id?: number;
  public subject?: User;
  public admin?: User;
  public date?: Date;
  public createdDate?: Date;
  public updateDate?: Date;
  public isComplete?: boolean;
  public haveCompletedSurvey?: boolean;
  public unablesCount?: number;
  public pages?: AssessmentPageInterface[];
  public analysis?: AssessmentAnalysisInterface;

  constructor({
    id = undefined,
    subject = undefined,
    admin = undefined,
    date = undefined,
    createdDate = undefined,
    updateDate = undefined,
    isComplete = undefined,
    haveCompletedSurvey = undefined,
    pages = undefined,
    analysis = undefined,
    }: AssessmentInterface) {
    this.id = id;
    this.subject = subject;
    this.admin = admin;
    this.date = date;
    this.createdDate = createdDate;
    this.updateDate = updateDate;
    this.isComplete = isComplete;
    this.haveCompletedSurvey = haveCompletedSurvey;
    this.pages = pages;
    this.analysis = analysis;
  }
}
